"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentBuilder = exports.AccordionBody = exports.AccordionHeading = exports.AccordionDummy = exports.AccordionBlock = exports.SideBySideColumn = exports.SideBySideDummy = exports.SideBySideBlock = exports.TableDummy = exports.TableCell = exports.TableBlock = exports.HorizontalRuleBlock = exports.IframeBlock = exports.GoogleMapsBlock = exports.VideoBlock = exports.ImageBlock = exports.BlockBuilder = exports.Link = exports.Variable = exports.Break = exports.InlineBuilder = exports.TextBuilder = exports.MarkBuilder = void 0;
var lodash_1 = __importDefault(require("lodash"));
var SideBySide_1 = require("ContentTokens/DataModels/SideBySide");
var Models_1 = require("ContentTokens/Models");
var OBJECT_TYPES = {
    BLOCK: "block",
    TEXT: "text",
    INLINE: "inline",
    MARK: "mark",
    LEAF: "leaf",
    DOCUMENT: "document",
};
var MarkBuilder = (function () {
    function MarkBuilder(type, data) {
        this.type = type;
        this.data = data || {};
    }
    MarkBuilder.prototype.build = function () {
        return {
            type: this.type,
            data: this.data,
        };
    };
    return MarkBuilder;
}());
exports.MarkBuilder = MarkBuilder;
var TextBuilder = (function () {
    function TextBuilder(text) {
        this.text = text;
        this.marks = [];
    }
    TextBuilder.prototype.addMark = function (type, data) {
        this.marks.push(new MarkBuilder(type, data));
        return this;
    };
    TextBuilder.prototype.setSelection = function (path) {
        return path;
    };
    TextBuilder.prototype.build = function () {
        return {
            text: this.text,
            marks: this.marks.map(function (x) { return x.build(); }),
        };
    };
    return TextBuilder;
}());
exports.TextBuilder = TextBuilder;
var InlineBuilder = (function () {
    function InlineBuilder() {
        this.type = "";
        this.nodes = [];
        this.isVoid = false;
    }
    InlineBuilder.prototype.setSelection = function (path) {
        var augmentedPath = path;
        augmentedPath.unshift(this.nodes.length - 1);
        return augmentedPath;
    };
    InlineBuilder.prototype.addMark = function (type, data) {
        return this;
    };
    return InlineBuilder;
}());
exports.InlineBuilder = InlineBuilder;
var Break = (function (_super) {
    __extends(Break, _super);
    function Break() {
        var _this = _super.call(this) || this;
        _this.type = Models_1.InlineType.LineBreak;
        _this.isVoid = true;
        _this.nodes.push(new TextBuilder(""));
        return _this;
    }
    Break.prototype.getKey = function () {
        return 2;
    };
    Break.prototype.build = function () {
        return {
            type: this.type,
            isVoid: this.isVoid,
            children: [this.nodes[0].build()],
        };
    };
    return Break;
}(InlineBuilder));
exports.Break = Break;
var Variable = (function (_super) {
    __extends(Variable, _super);
    function Variable(variableName, variableLabel, providerType, substitutionToken) {
        var _this = _super.call(this) || this;
        _this.type = Models_1.InlineType.Variable;
        _this.data = {
            variableName: variableName,
            variableLabel: variableLabel,
            providerType: providerType,
            isBold: false,
            isItalic: false,
            isStrikethrough: false,
            substitutionToken: substitutionToken,
        };
        _this.isVoid = true;
        _this.nodes.push(new TextBuilder(""));
        return _this;
    }
    Variable.prototype.build = function () {
        return {
            type: this.type,
            data: this.data,
            isVoid: this.isVoid,
            children: [this.nodes[0].build()],
        };
    };
    return Variable;
}(InlineBuilder));
exports.Variable = Variable;
var Link = (function (_super) {
    __extends(Link, _super);
    function Link(url) {
        if (url === void 0) { url = "https://www.qwilr.com"; }
        var _this = _super.call(this) || this;
        _this.type = Models_1.InlineType.Link;
        _this.data = {
            href: url,
        };
        return _this;
    }
    Link.prototype.addText = function (content) {
        this.nodes.push(new TextBuilder(content));
        return this;
    };
    Link.prototype.addMark = function (type, data) {
        this.nodes[this.nodes.length - 1].addMark(type, data);
        return this;
    };
    Link.prototype.build = function () {
        return {
            type: this.type,
            data: this.data,
            children: this.nodes.map(function (x) { return x.build(); }),
        };
    };
    return Link;
}(InlineBuilder));
exports.Link = Link;
var BlockBuilder = (function () {
    function BlockBuilder(type, data) {
        this.type = type;
        this.isVoid = false;
        this.data = {};
        this.nodes = [];
        if (data) {
            this.data = data;
        }
    }
    BlockBuilder.prototype.addText = function (content) {
        var endNode = this.nodes[this.nodes.length - 1];
        if (this.nodes.length && endNode.addText != undefined) {
            endNode.addText(content);
        }
        else {
            this.nodes.push(new TextBuilder(content));
        }
        return this;
    };
    BlockBuilder.prototype.addInline = function (type, data) {
        switch (type) {
            case "link":
                this.nodes.push(new Link(data.href));
                break;
            case "lineBreak":
                this.nodes.push(new Break());
                break;
            case "variable":
                this.nodes.push(new Variable(data.variableName, data.variableLabel, data.providerType, data.substitutionToken));
                break;
            default:
                break;
        }
        return this;
    };
    BlockBuilder.prototype.addMark = function (type, data) {
        this.nodes[this.nodes.length - 1].addMark(type, data);
        return this;
    };
    BlockBuilder.prototype.setSelection = function (path) {
        if (!this.nodes.length) {
            return path;
        }
        var augmentedPath = this.nodes[this.nodes.length - 1].setSelection(path);
        augmentedPath.unshift(this.nodes.length - 1);
        return augmentedPath;
    };
    BlockBuilder.prototype.hasData = function () {
        return true;
    };
    BlockBuilder.prototype.build = function () {
        if (this.nodes.length === 0) {
            this.addText("");
        }
        var value = {
            type: this.type,
            isVoid: this.isVoid,
            children: this.nodes.map(function (x) { return x.build(); }),
        };
        if (this.hasData()) {
            return __assign(__assign({}, value), { data: this.data });
        }
        else {
            return value;
        }
    };
    return BlockBuilder;
}());
exports.BlockBuilder = BlockBuilder;
var ImageBlock = (function (_super) {
    __extends(ImageBlock, _super);
    function ImageBlock(data) {
        var _this = this;
        if (!data.width) {
            data.width = 100;
        }
        var dataToSet = {
            src: data.src,
            width: data.width,
        };
        if (data.href) {
            dataToSet.href = data.href;
        }
        if (data.alignment) {
            dataToSet.alignment = data.alignment;
        }
        if (data.frame) {
            dataToSet.frame = data.frame;
        }
        if (data.uploadId) {
            dataToSet.uploadId = data.uploadId;
        }
        if (data.variable) {
            dataToSet.variable = data.variable;
        }
        _this = _super.call(this, Models_1.BlockType.Image, dataToSet) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    ImageBlock.prototype.addText = function () {
        throw new Error("cant add text to image block");
    };
    ImageBlock.prototype.addInline = function () {
        throw new Error("cant add inline to image block");
    };
    ImageBlock.prototype.addMark = function () {
        throw new Error("cant add mark to image block");
    };
    return ImageBlock;
}(BlockBuilder));
exports.ImageBlock = ImageBlock;
var VideoBlock = (function (_super) {
    __extends(VideoBlock, _super);
    function VideoBlock(data) {
        var _this = this;
        var _a, _b;
        var dataToSet = {};
        if (data.variable != null) {
            dataToSet.variable = data.variable;
        }
        else {
            dataToSet.embedUrl = data.embedUrl;
        }
        dataToSet.displayUrl = (_a = data.displayUrl) !== null && _a !== void 0 ? _a : "";
        dataToSet.width = (_b = data.width) !== null && _b !== void 0 ? _b : 100;
        _this = _super.call(this, Models_1.BlockType.Video, dataToSet) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    VideoBlock.prototype.addText = function () {
        throw new Error("cant add text to video block");
    };
    VideoBlock.prototype.addInline = function () {
        throw new Error("cant add inline to video block");
    };
    VideoBlock.prototype.addMark = function () {
        throw new Error("cant add mark to video block");
    };
    return VideoBlock;
}(BlockBuilder));
exports.VideoBlock = VideoBlock;
var GoogleMapsBlock = (function (_super) {
    __extends(GoogleMapsBlock, _super);
    function GoogleMapsBlock(data) {
        var _this = this;
        var dataToSet = {
            displayUrl: data.displayUrl,
            embedUrl: data.embedUrl,
            width: data.width,
        };
        _this = _super.call(this, Models_1.BlockType.GoogleMaps, dataToSet) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    GoogleMapsBlock.prototype.addText = function () {
        throw new Error("cant add text to google maps block");
    };
    GoogleMapsBlock.prototype.addInline = function () {
        throw new Error("cant add inline to google maps block");
    };
    GoogleMapsBlock.prototype.addMark = function () {
        throw new Error("cant add mark to google maps block");
    };
    return GoogleMapsBlock;
}(BlockBuilder));
exports.GoogleMapsBlock = GoogleMapsBlock;
var IframeBlock = (function (_super) {
    __extends(IframeBlock, _super);
    function IframeBlock(data) {
        var _this = this;
        var dataToSet = {
            embedPreset: data.embedPreset,
            embedUrl: data.embedUrl,
            width: data.width,
            height: data.height,
            alignment: data.alignment,
        };
        _this = _super.call(this, Models_1.BlockType.Iframe, dataToSet) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    IframeBlock.prototype.addText = function () {
        throw new Error("cant add text to iframe block");
    };
    IframeBlock.prototype.addInline = function () {
        throw new Error("cant add inline to iframe block");
    };
    IframeBlock.prototype.addMark = function () {
        throw new Error("cant add mark to iframe block");
    };
    return IframeBlock;
}(BlockBuilder));
exports.IframeBlock = IframeBlock;
var HorizontalRuleBlock = (function (_super) {
    __extends(HorizontalRuleBlock, _super);
    function HorizontalRuleBlock() {
        var _this = _super.call(this, Models_1.BlockType.HorizontalRule) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    HorizontalRuleBlock.prototype.addText = function () {
        throw new Error("cant add text to horizontal rule block");
    };
    HorizontalRuleBlock.prototype.addInline = function () {
        throw new Error("cant add inline to horizontal rule block");
    };
    HorizontalRuleBlock.prototype.addMark = function () {
        throw new Error("cant add mark to horizontal rule block");
    };
    HorizontalRuleBlock.prototype.hasData = function () {
        return false;
    };
    return HorizontalRuleBlock;
}(BlockBuilder));
exports.HorizontalRuleBlock = HorizontalRuleBlock;
var TableBlock = (function (_super) {
    __extends(TableBlock, _super);
    function TableBlock(_a) {
        var rows = _a.rows, columns = _a.columns;
        var _this = _super.call(this, Models_1.BlockType.Table) || this;
        _this.nodes = [new TableDummy()];
        _this.data = {
            rows: rows,
            columns: columns,
            columnBorders: _this.generateDefaultSpacing(columns),
            selection: null,
        };
        return _this;
    }
    TableBlock.prototype.addTableRow = function () {
        return this._addTableRow(new TableRow());
    };
    TableBlock.prototype.addTableRepeatingRow = function (data) {
        return this._addTableRow(new TableRepeatingRow(data));
    };
    TableBlock.prototype.addTableCell = function () {
        var currentRow = lodash_1.default.last(this.nodes);
        var createNewRow = currentRow.type === Models_1.BlockType.TableDummy || currentRow.nodes.length >= this.data.columns;
        if (createNewRow) {
            if (this.nodes.length === this.data.rows + 1) {
                throw new Error("cannot add any more cells as exceeds rows bound");
            }
            var newRow = new TableRow();
            newRow.nodes.push(new TableCell());
            this.nodes.push(newRow);
        }
        else {
            currentRow.nodes.push(new TableCell());
        }
        return this;
    };
    TableBlock.prototype.addInline = function (type, data) {
        this.currentCell.addInline(type, data);
        return this;
    };
    TableBlock.prototype.addText = function (content) {
        this.currentCell.addText(content);
        return this;
    };
    TableBlock.prototype.addBlock = function (type, data) {
        this.currentCell.addBlock(type, data);
        return this;
    };
    TableBlock.prototype._addTableRow = function (newRow) {
        if (this.nodes.length === this.data.rows + 1) {
            throw new Error("cannot add any more cells as exceeds rows bound");
        }
        this.nodes.push(newRow);
        return this;
    };
    Object.defineProperty(TableBlock.prototype, "currentCell", {
        get: function () {
            return lodash_1.default.last(lodash_1.default.last(this.nodes).nodes);
        },
        enumerable: false,
        configurable: true
    });
    TableBlock.prototype.generateDefaultSpacing = function (columns) {
        var colWidth = 100 / columns;
        var columnBorders = [];
        for (var i = 0; i <= columns; i++) {
            columnBorders.push(colWidth * i);
        }
        return columnBorders;
    };
    return TableBlock;
}(BlockBuilder));
exports.TableBlock = TableBlock;
var TableCell = (function (_super) {
    __extends(TableCell, _super);
    function TableCell() {
        return _super.call(this, Models_1.BlockType.TableCell) || this;
    }
    TableCell.prototype.hasData = function () {
        return false;
    };
    TableCell.prototype.addBlock = function (type, data) {
        if (this.nodes.length) {
            maybeAddEmptyTextNodeBlock(this.nodes[this.nodes.length - 1]);
        }
        switch (type) {
            case Models_1.BlockType.Image:
                this.nodes.push(new ImageBlock(data));
                break;
            case Models_1.BlockType.Video:
                this.nodes.push(new VideoBlock(data));
                break;
            case Models_1.BlockType.GoogleMaps:
                this.nodes.push(new GoogleMapsBlock(data));
                break;
            case Models_1.BlockType.Iframe:
                this.nodes.push(new IframeBlock(data));
                break;
            case Models_1.BlockType.HorizontalRule:
                this.nodes.push(new HorizontalRuleBlock());
                break;
            default:
                this.nodes.push(new BlockBuilder(type, data));
                break;
        }
        return this;
    };
    return TableCell;
}(BlockBuilder));
exports.TableCell = TableCell;
var TableRow = (function (_super) {
    __extends(TableRow, _super);
    function TableRow() {
        return _super.call(this, Models_1.BlockType.TableRow) || this;
    }
    TableRow.prototype.addBlock = function (type, data) {
        throw new Error("cant add block to table row without cells");
    };
    TableRow.prototype.addText = function () {
        throw new Error("cant add text to table row without cells");
    };
    TableRow.prototype.addInline = function (type, data) {
        throw new Error("cant add inline to table row without cells");
    };
    TableRow.prototype.addMark = function () {
        throw new Error("cant add mark to table row without cells");
    };
    TableRow.prototype.hasData = function () {
        return false;
    };
    return TableRow;
}(BlockBuilder));
var TableRepeatingRow = (function (_super) {
    __extends(TableRepeatingRow, _super);
    function TableRepeatingRow(data) {
        if (data === void 0) { data = {}; }
        var _this = _super.call(this, Models_1.BlockType.TableRepeatingRow) || this;
        _this.data = data;
        return _this;
    }
    TableRepeatingRow.prototype.addBlock = function (type, data) {
        throw new Error("cant add block to table repeating row without cells");
    };
    TableRepeatingRow.prototype.addText = function () {
        throw new Error("cant add text to table repeating row without cells");
    };
    TableRepeatingRow.prototype.addInline = function (type, data) {
        throw new Error("cant add inline to table repeating row without cells");
    };
    TableRepeatingRow.prototype.addMark = function () {
        throw new Error("cant add mark to table row repeating without cells");
    };
    return TableRepeatingRow;
}(BlockBuilder));
var TableDummy = (function (_super) {
    __extends(TableDummy, _super);
    function TableDummy() {
        var _this = _super.call(this, Models_1.BlockType.TableDummy) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    TableDummy.prototype.addBlock = function (type, data) {
        throw new Error("cant add block to table without cells");
    };
    TableDummy.prototype.addText = function () {
        throw new Error("cant add text to table without cells");
    };
    TableDummy.prototype.addInline = function (type, data) {
        throw new Error("cant add inline to table without cells");
    };
    TableDummy.prototype.addMark = function () {
        throw new Error("cant add mark to table without cells");
    };
    TableDummy.prototype.hasData = function () {
        return false;
    };
    return TableDummy;
}(BlockBuilder));
exports.TableDummy = TableDummy;
var SideBySideBlock = (function (_super) {
    __extends(SideBySideBlock, _super);
    function SideBySideBlock() {
        var _this = _super.call(this, Models_1.BlockType.SideBySide) || this;
        _this.nodes = [new SideBySideDummy()];
        _this.data = {
            selection: null,
            selectedColumns: [],
            placeholderIndex: null,
            width: SideBySide_1.SideBySideWidth.Wide,
            percent: 50,
            alignment: SideBySide_1.SideBySideAlignment.Normal,
        };
        return _this;
    }
    SideBySideBlock.prototype.addSideBySideColumn = function () {
        this.nodes.push(new SideBySideColumn());
        return this;
    };
    SideBySideBlock.prototype.addInline = function (type, data) {
        this.nodes[this.nodes.length - 1].addInline(type, data);
        return this;
    };
    SideBySideBlock.prototype.addBlock = function (type, data) {
        this.nodes[this.nodes.length - 1].addBlock(type, data);
        return this;
    };
    return SideBySideBlock;
}(BlockBuilder));
exports.SideBySideBlock = SideBySideBlock;
var SideBySideDummy = (function (_super) {
    __extends(SideBySideDummy, _super);
    function SideBySideDummy() {
        var _this = _super.call(this, Models_1.BlockType.SideBySideDummy) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    SideBySideDummy.prototype.hasData = function () {
        return false;
    };
    SideBySideDummy.prototype.addBlock = function (type, data) {
        throw new Error("cant add block to sideBySide without columns");
    };
    SideBySideDummy.prototype.addText = function () {
        throw new Error("cant add text to sideBySide without columns");
    };
    SideBySideDummy.prototype.addInline = function (type, data) {
        throw new Error("cant add inline to sideBySide without columns");
    };
    SideBySideDummy.prototype.addMark = function () {
        throw new Error("cant add mark to sideBySide without columns");
    };
    return SideBySideDummy;
}(BlockBuilder));
exports.SideBySideDummy = SideBySideDummy;
var SideBySideColumn = (function (_super) {
    __extends(SideBySideColumn, _super);
    function SideBySideColumn() {
        return _super.call(this, Models_1.BlockType.SideBySideColumn) || this;
    }
    SideBySideColumn.prototype.hasData = function () {
        return false;
    };
    SideBySideColumn.prototype.addBlock = function (type, data) {
        if (this.nodes.length) {
            maybeAddEmptyTextNodeBlock(this.nodes[this.nodes.length - 1]);
        }
        switch (type) {
            case Models_1.BlockType.Image:
                this.nodes.push(new ImageBlock(data));
                break;
            case Models_1.BlockType.Video:
                this.nodes.push(new VideoBlock(data));
                break;
            case Models_1.BlockType.SideBySide:
                this.nodes.push(new SideBySideBlock());
                break;
            case Models_1.BlockType.SideBySideColumn:
                this.nodes.reverse().find(function (node) {
                    return node["type"] === Models_1.BlockType.SideBySide;
                }).addSideBySideColumn();
                break;
            case Models_1.BlockType.HorizontalRule:
                this.nodes.push(new HorizontalRuleBlock());
                break;
            default:
                this.nodes.push(new BlockBuilder(type, data));
                break;
        }
        return this;
    };
    return SideBySideColumn;
}(BlockBuilder));
exports.SideBySideColumn = SideBySideColumn;
var AccordionBlock = (function (_super) {
    __extends(AccordionBlock, _super);
    function AccordionBlock(data) {
        var _this = _super.call(this, Models_1.BlockType.Accordion) || this;
        _this.nodes = [new AccordionDummy()];
        _this.data = __assign({ expanded: false }, data);
        return _this;
    }
    AccordionBlock.prototype.addBlock = function (type, data) {
        this.nodes[this.nodes.length - 1].addBlock(type, data);
        return this;
    };
    AccordionBlock.prototype.addInline = function (type, data) {
        this.nodes[this.nodes.length - 1].addInline(type, data);
        return this;
    };
    AccordionBlock.prototype.addAccordionHeading = function () {
        this.nodes.push(new AccordionHeading());
        return this;
    };
    AccordionBlock.prototype.addAccordionBody = function () {
        this.nodes.push(new AccordionBody());
        return this;
    };
    return AccordionBlock;
}(BlockBuilder));
exports.AccordionBlock = AccordionBlock;
var AccordionDummy = (function (_super) {
    __extends(AccordionDummy, _super);
    function AccordionDummy() {
        var _this = _super.call(this, Models_1.BlockType.AccordionDummy) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    AccordionDummy.prototype.hasData = function () {
        return false;
    };
    AccordionDummy.prototype.addBlock = function (type, data) {
        throw new Error("cant add block to accordion without heading or body");
    };
    AccordionDummy.prototype.addText = function () {
        throw new Error("cant add text to accordion without heading or body");
    };
    AccordionDummy.prototype.addInline = function (type, data) {
        throw new Error("cant add inline to accordion without heading or body");
    };
    AccordionDummy.prototype.addMark = function () {
        throw new Error("cant add mark to accordion without heading or body");
    };
    return AccordionDummy;
}(BlockBuilder));
exports.AccordionDummy = AccordionDummy;
var AccordionHeading = (function (_super) {
    __extends(AccordionHeading, _super);
    function AccordionHeading() {
        return _super.call(this, Models_1.BlockType.AccordionHeading) || this;
    }
    AccordionHeading.prototype.hasData = function () {
        return false;
    };
    AccordionHeading.prototype.addBlock = function (type, data) {
        this.nodes.push(new BlockBuilder(type, data));
        return this;
    };
    return AccordionHeading;
}(BlockBuilder));
exports.AccordionHeading = AccordionHeading;
var AccordionBody = (function (_super) {
    __extends(AccordionBody, _super);
    function AccordionBody() {
        return _super.call(this, Models_1.BlockType.AccordionBody) || this;
    }
    AccordionBody.prototype.addBlock = function (type, data) {
        this.nodes.push(new BlockBuilder(type, data));
        return this;
    };
    return AccordionBody;
}(BlockBuilder));
exports.AccordionBody = AccordionBody;
var ContentLoopBlock = (function (_super) {
    __extends(ContentLoopBlock, _super);
    function ContentLoopBlock(data) {
        var _this = _super.call(this, Models_1.BlockType.ContentLoop, data) || this;
        _this.nodes = [new ContentLoopDummy(), new ContentLoopBody()];
        return _this;
    }
    Object.defineProperty(ContentLoopBlock.prototype, "body", {
        get: function () {
            return this.nodes[1];
        },
        enumerable: false,
        configurable: true
    });
    ContentLoopBlock.prototype.addBlock = function (type, data) {
        this.body.addBlock(type, data);
        return this;
    };
    ContentLoopBlock.prototype.addInline = function (type, data) {
        this.body.addInline(type, data);
        return this;
    };
    return ContentLoopBlock;
}(BlockBuilder));
var ContentLoopBody = (function (_super) {
    __extends(ContentLoopBody, _super);
    function ContentLoopBody() {
        return _super.call(this, Models_1.BlockType.ContentLoopBody) || this;
    }
    Object.defineProperty(ContentLoopBody.prototype, "lastBlock", {
        get: function () {
            return this.nodes[this.nodes.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    ContentLoopBody.prototype.addBlock = function (type, data) {
        if (this.nodes.length) {
            maybeAddEmptyTextNodeBlock(this.lastBlock);
        }
        switch (type) {
            case Models_1.BlockType.Image:
                this.nodes.push(new ImageBlock(data));
                break;
            case Models_1.BlockType.Video:
                this.nodes.push(new VideoBlock(data));
                break;
            case Models_1.BlockType.SideBySide:
                this.nodes.push(new SideBySideBlock());
                break;
            case Models_1.BlockType.SideBySideColumn:
                this.nodes.reverse().find(function (node) {
                    return node["type"] === Models_1.BlockType.SideBySide;
                }).addSideBySideColumn();
                break;
            case Models_1.BlockType.HorizontalRule:
                this.nodes.push(new HorizontalRuleBlock());
                break;
            default:
                this.nodes.push(new BlockBuilder(type, data));
                break;
        }
        return this;
    };
    ContentLoopBody.prototype.addInline = function (type, data) {
        if (!this.lastBlock) {
            throw new Error("cant add inline to non-existant block");
        }
        this.lastBlock.addInline(type, data);
        return this;
    };
    ContentLoopBody.prototype.hasData = function () {
        return false;
    };
    return ContentLoopBody;
}(BlockBuilder));
var ContentLoopDummy = (function (_super) {
    __extends(ContentLoopDummy, _super);
    function ContentLoopDummy() {
        var _this = _super.call(this, Models_1.BlockType.ContentLoopDummy) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    ContentLoopDummy.prototype.addBlock = function (type, data) {
        throw new Error("cant add block to contentLoopDummy");
    };
    ContentLoopDummy.prototype.addText = function () {
        throw new Error("cant add text to contentLoopDummy");
    };
    ContentLoopDummy.prototype.addInline = function (type, data) {
        throw new Error("cant add inline to contentLoopDummy");
    };
    ContentLoopDummy.prototype.addMark = function () {
        throw new Error("cant add mark to contentLoopDummy");
    };
    ContentLoopDummy.prototype.hasData = function () {
        return false;
    };
    return ContentLoopDummy;
}(BlockBuilder));
var ROICalculatorBlock = (function (_super) {
    __extends(ROICalculatorBlock, _super);
    function ROICalculatorBlock(data) {
        var _this = _super.call(this, Models_1.BlockType.ROICalculator, data) || this;
        _this.isVoid = true;
        maybeAddEmptyTextNodeInline(_this.nodes);
        return _this;
    }
    ROICalculatorBlock.prototype.addBlock = function (type, data) {
        throw new Error("cant add block to roiCalculator");
    };
    ROICalculatorBlock.prototype.addText = function () {
        throw new Error("cant add text to roiCalculator");
    };
    ROICalculatorBlock.prototype.addInline = function (type, data) {
        throw new Error("cant add inline to roiCalculator");
    };
    ROICalculatorBlock.prototype.addMark = function () {
        throw new Error("cant add mark to roiCalculator");
    };
    ROICalculatorBlock.prototype.hasData = function () {
        return true;
    };
    return ROICalculatorBlock;
}(BlockBuilder));
var DocumentBuilder = (function () {
    function DocumentBuilder() {
        this.data = {};
        this.nodes = [];
    }
    Object.defineProperty(DocumentBuilder.prototype, "lastBlock", {
        get: function () {
            return this.nodes[this.nodes.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    DocumentBuilder.prototype.addTableBlock = function (type, data) {
        if (!this.lastBlock || !(this.lastBlock instanceof TableBlock)) {
            throw new Error("cant add block to non-existant table");
        }
        this.lastBlock.addBlock(type, data);
        return this;
    };
    DocumentBuilder.prototype.addSideBySideBlock = function (type, data) {
        if (!this.lastBlock || !(this.lastBlock instanceof SideBySideBlock)) {
            throw new Error("cant add block to non-existant side by side");
        }
        this.lastBlock.addBlock(type, data);
        return this;
    };
    DocumentBuilder.prototype.addContentLoopBlock = function (type, data) {
        if (!this.lastBlock || !(this.lastBlock instanceof ContentLoopBlock)) {
            throw new Error("cant add block to non-existant content loop");
        }
        this.lastBlock.addBlock(type, data);
        return this;
    };
    DocumentBuilder.prototype.addAccordionBlock = function (type, data) {
        if (!this.lastBlock || !(this.lastBlock instanceof AccordionBlock)) {
            throw new Error("cant add block to non-existant Accordion");
        }
        this.lastBlock.addBlock(type, data);
        return this;
    };
    DocumentBuilder.prototype.addBlock = function (type, data) {
        switch (type) {
            case Models_1.BlockType.Image:
                this.nodes.push(new ImageBlock(data));
                break;
            case Models_1.BlockType.Video:
                this.nodes.push(new VideoBlock(data));
                break;
            case Models_1.BlockType.GoogleMaps:
                this.nodes.push(new GoogleMapsBlock(data));
                break;
            case Models_1.BlockType.Iframe:
                this.nodes.push(new IframeBlock(data));
                break;
            case Models_1.BlockType.Table:
                this.nodes.push(new TableBlock(data));
                break;
            case Models_1.BlockType.TableRow:
                this.lastBlock.addTableRow();
                break;
            case Models_1.BlockType.TableRepeatingRow:
                this.lastBlock.addTableRepeatingRow(data);
                break;
            case Models_1.BlockType.TableCell:
                this.nodes[this.nodes.length - 1].addTableCell();
                break;
            case Models_1.BlockType.HorizontalRule:
                this.nodes.push(new HorizontalRuleBlock());
                break;
            case Models_1.BlockType.SideBySide:
                this.nodes.push(new SideBySideBlock());
                break;
            case Models_1.BlockType.SideBySideColumn:
                this.nodes[this.nodes.length - 1].addSideBySideColumn();
                break;
            case Models_1.BlockType.ContentLoop:
                this.nodes.push(new ContentLoopBlock(data));
                break;
            case Models_1.BlockType.ROICalculator:
                this.nodes.push(new ROICalculatorBlock(data));
                break;
            case Models_1.BlockType.Accordion:
                this.nodes.push(new AccordionBlock(data));
                break;
            case Models_1.BlockType.AccordionHeading:
                this.nodes[this.nodes.length - 1].addAccordionHeading();
                break;
            case Models_1.BlockType.AccordionBody:
                this.nodes[this.nodes.length - 1].addAccordionBody();
                break;
            default:
                this.nodes.push(new BlockBuilder(type, data));
                break;
        }
        return this;
    };
    DocumentBuilder.prototype.addText = function (content) {
        this.nodes[this.nodes.length - 1].addText(content);
        return this;
    };
    DocumentBuilder.prototype.addInline = function (type, data) {
        this.nodes[this.nodes.length - 1].addInline(type, data);
        return this;
    };
    DocumentBuilder.prototype.addMark = function (type, data) {
        this.nodes[this.nodes.length - 1].addMark(type, data);
        return this;
    };
    DocumentBuilder.prototype.setSelection = function (path) {
        if (!this.nodes.length) {
            return path;
        }
        var augmentedPath = this.nodes[this.nodes.length - 1].setSelection(path);
        augmentedPath.unshift(this.nodes.length - 1);
        return augmentedPath;
    };
    DocumentBuilder.prototype.build = function () {
        if (this.nodes.length) {
            maybeAddEmptyTextNodeBlock(this.nodes[this.nodes.length - 1].nodes);
        }
        return this.nodes.map(function (x) { return x.build(); });
    };
    return DocumentBuilder;
}());
exports.DocumentBuilder = DocumentBuilder;
var ValueBuilder = (function () {
    function ValueBuilder() {
        this.document = new DocumentBuilder();
        this.selection = {
            anchor: {},
            focus: {},
        };
    }
    ValueBuilder.prototype.addBlock = function (type, data) {
        this.document.addBlock(type, data);
        return this;
    };
    ValueBuilder.prototype.addTableBlock = function (type, data) {
        this.document.addTableBlock(type, data);
        return this;
    };
    ValueBuilder.prototype.addSideBySideBlock = function (type, data) {
        this.document.addSideBySideBlock(type, data);
        return this;
    };
    ValueBuilder.prototype.addContentLoopBlock = function (type, data) {
        this.document.addContentLoopBlock(type, data);
        return this;
    };
    ValueBuilder.prototype.addAccordionBlock = function (type, data) {
        this.document.addAccordionBlock(type, data);
        return this;
    };
    ValueBuilder.prototype.addText = function (content) {
        this.document.addText(content);
        return this;
    };
    ValueBuilder.prototype.addInline = function (type, data) {
        this.document.addInline(type, data);
        return this;
    };
    ValueBuilder.prototype.addMark = function (type, data) {
        this.document.addMark(type, data);
        return this;
    };
    ValueBuilder.prototype.setSelection = function () {
        var selection = [];
        return this.document.setSelection(selection);
    };
    ValueBuilder.prototype.addAnchor = function (offset) {
        if (offset === void 0) { offset = 0; }
        this.selection.anchor.path = this.setSelection();
        this.selection.anchor.offset = offset;
        return this;
    };
    ValueBuilder.prototype.addFocus = function (offset) {
        if (offset === void 0) { offset = 0; }
        this.selection.focus.path = this.setSelection();
        this.selection.focus.offset = offset;
        return this;
    };
    ValueBuilder.prototype.setIsFocused = function (isFocused) {
        this.selection.isFocused = isFocused;
        return this;
    };
    ValueBuilder.prototype.setIsCollapsed = function (isCollapsed) {
        this.selection.isCollapsed = isCollapsed;
        return this;
    };
    ValueBuilder.prototype.addCursor = function (offset) {
        if (offset === void 0) { offset = 0; }
        this.selection.focus.path = this.setSelection();
        this.selection.focus.offset = offset;
        this.selection.anchor.path = this.setSelection();
        this.selection.anchor.offset = offset;
        return this;
    };
    ValueBuilder.prototype.build = function () {
        var value = {
            children: this.document.build(),
        };
        if (this.selection.focus.key && this.selection.anchor.key) {
            value.selection = this.selection;
        }
        else if (this.selection.focus.path && this.selection.anchor.path) {
            value.selection = this.selection;
        }
        return value;
    };
    return ValueBuilder;
}());
exports.default = ValueBuilder;
var maybeAddEmptyTextNodeInline = function (nodeList) {
    if (!nodeList.length || nodeList[nodeList.length - 1].object != OBJECT_TYPES.TEXT) {
        nodeList.push(new TextBuilder(""));
    }
};
var maybeAddEmptyTextNodeBlock = function (nodeList) {
    if (nodeList.length) {
        if (nodeList[nodeList.length - 1].object == OBJECT_TYPES.INLINE) {
            nodeList.push(new TextBuilder(""));
        }
    }
};
